import React, { useRef } from 'react';
import { ModalBody, ModalHeader } from 'reactstrap';
import { SellerDataAndDocumentRequestForm } from '../../../AdminMarketplace/ActionDefinitionForm/SellerDataAndDocumentRequestForm/SellerDataAndDocumentRequestForm';
import { LinkedDataRequestProject } from '../../../../slices/marketplace/timeline/models/linked-data-request-project.model';
import ButtonLoader from '../../../../components/Layout/Buttons/ButtonLoader';
import Rodal from '../../../../components/Rodal/Rodal';
import { useStateSelector } from '../../../../store/selectors';
import createNotification from '../../../../utils/createNotification';
import { LinkedDataRequestProjectStatus } from '../../../../slices/marketplace/timeline/models/enums/linked-data-request-project-status.enum';
import "./CreateDataAndDocsModal.scss";

interface CreateDataAndDocsModalProps {
    engagementId: number;
    isVisible: boolean;
    onClose: () => void;
    onSubmit: () => void;
}
export const CreateDataAndDocsModal = (props: CreateDataAndDocsModalProps) => {
    const axios = useStateSelector((state) => state.core.axios);
    const formRef = useRef<any>();
    const [isSaving, setIsSaving] = React.useState(false);

    const onSubmit = (project: LinkedDataRequestProject) => {
        setIsSaving(true);
        axios
            .post(
                `/api/Marketplace/Engagements/${props.engagementId}/DataRequests`,
                {
                    ...project,
                    status: LinkedDataRequestProjectStatus.InProgress,
                }
            )
            .then((response) => {
                if (response.status !== 200) {
                    createNotification(
                        'An unexpected error occurred while saving the data request project.',
                        'error'
                    );
                    return;
                } else {
                    createNotification(
                        'Data request project created successfully.',
                        'success'
                    );
                    props.onSubmit();
                }
            })
            .catch(() => {
                createNotification(
                    'An unexpected error occurred while saving the data request project.',
                    'error'
                );
            })
            .finally(() => {
                setIsSaving(false);
            });
    };

    return (
        <Rodal
            visible={props.isVisible}
            animation={'fade'}
            onClose={props.onClose}
            showMask={true}
            width={600}
            closeOnEsc
            className="create-data-and-docs-modal"
            center>
            <ModalHeader className="popup-header">
                <div className="d-flex align-items-center">
                    <span>Add practice Data & Docs</span>
                </div>
            </ModalHeader>
            <ModalBody>
                <SellerDataAndDocumentRequestForm
                    ref={formRef}
                    disabled={false}
                    currentEvent={undefined}
                    onSubmit={function (
                        _1,
                        _2,
                        _3,
                        dataRequestProject?: LinkedDataRequestProject
                    ): void {
                        onSubmit(dataRequestProject);
                    }}
                    dataRequestProjects={[]}
                    isCreateMode={true}></SellerDataAndDocumentRequestForm>

                <div className="mt-auto d-flex justify-content-end buttons-wrapper">
                    <button
                        type="button"
                        className="btn btn-cancel"
                        onClick={() => props.onClose()}>
                        Cancel
                    </button>
                    <ButtonLoader
                        buttonText={`Save`}
                        loaderButtonText={''}
                        disabled={isSaving}
                        isLoading={isSaving}
                        onClick={() => {
                            formRef?.current?.handleSubmit();
                        }}
                        type="button"
                        className={`btn btn-primary loader-submit`}
                    />
                </div>
            </ModalBody>
        </Rodal>
    );
};
